/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "AccessControlBadConfirmation",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        name: "AccessControlEnforcedDefaultAdminDelay",
        type: "error",
    },
    {
        inputs: [],
        name: "AccessControlEnforcedDefaultAdminRules",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "defaultAdmin",
                type: "address",
            },
        ],
        name: "AccessControlInvalidDefaultAdmin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "neededRole",
                type: "bytes32",
            },
        ],
        name: "AccessControlUnauthorizedAccount",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
        ],
        name: "AddressEmptyCode",
        type: "error",
    },
    {
        inputs: [],
        name: "AmountMustBeGreaterThanZero",
        type: "error",
    },
    {
        inputs: [],
        name: "CantRenounceOwnerRole",
        type: "error",
    },
    {
        inputs: [],
        name: "ContractAlreadySet",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "ERC1967InvalidImplementation",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC1967NonPayable",
        type: "error",
    },
    {
        inputs: [],
        name: "EnforcedPause",
        type: "error",
    },
    {
        inputs: [],
        name: "ExpectedPause",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedCall",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedToGetAssetDecimals",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedToTransfer",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "contractAddress",
                type: "address",
            },
        ],
        name: "InvalidContractAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInitialization",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "InvalidRoleAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "NotInitializing",
        type: "error",
    },
    {
        inputs: [],
        name: "ReentrancyGuardReentrantCall",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "bits",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "SafeCastOverflowedUintDowncast",
        type: "error",
    },
    {
        inputs: [],
        name: "UUPSUnauthorizedCallContext",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "slot",
                type: "bytes32",
            },
        ],
        name: "UUPSUnsupportedProxiableUUID",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DefaultAdminDelayChangeCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
            {
                indexed: false,
                internalType: "uint48",
                name: "effectSchedule",
                type: "uint48",
            },
        ],
        name: "DefaultAdminDelayChangeScheduled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DefaultAdminTransferCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint48",
                name: "acceptSchedule",
                type: "uint48",
            },
        ],
        name: "DefaultAdminTransferScheduled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Donate",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint64",
                name: "version",
                type: "uint64",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "initialOwner",
                type: "address",
            },
        ],
        name: "MUnityTrinityEulerInitialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "NewImplementation",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "representationToken",
                type: "address",
            },
        ],
        name: "RepresentationTokenSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "amountMinted",
                type: "uint256",
            },
        ],
        name: "Supply",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Withdraw",
        type: "event",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_INTERFACE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "acceptDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "beginDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "cancelDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
        ],
        name: "changeDefaultAdminDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdminDelay",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdminDelayIncreaseWait",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "donate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_unity",
                type: "address",
            },
            {
                internalType: "address",
                name: "_eulerPool",
                type: "address",
            },
            {
                internalType: "address",
                name: "_yieldToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "initialOwner",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingDefaultAdmin",
        outputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingDefaultAdminDelay",
        outputs: [
            {
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "protocolPool",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "representationToken",
        outputs: [
            {
                internalType: "contract IERC20Mintable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "rollbackDefaultAdminDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_representationToken",
                type: "address",
            },
        ],
        name: "setRepresentationToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "supply",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalAssets",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "unityToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "yieldToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class MUnityTrinityEuler__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
MUnityTrinityEuler__factory.bytecode = _bytecode;
MUnityTrinityEuler__factory.abi = _abi;
//# sourceMappingURL=MUnityTrinityEuler__factory.js.map